import { useState, useEffect } from 'react';
import {
  useUserLotteryStore,
  userLotteryStore,
} from '@/store/userLotteryStatusStore';
import { useRedemptionWallet } from '@/hooks/wallet';

export const GUIDE_MODAL_KEY = 'web3_points_guide_shown';
export const GUIDE_MODAL_EXPIRE = 30 * 24 * 60 * 60 * 1000; // 30天

const shouldShowGuide = () => {
  const shownTime = localStorage.getItem(GUIDE_MODAL_KEY);
  if (!shownTime) return true;

  const lastShownTime = parseInt(shownTime, 10);
  return Date.now() - lastShownTime > GUIDE_MODAL_EXPIRE;
};

export const useGuideModal = () => {
  const [showGuide, setShowGuide] = useState(false);
  const {
    isConnectedWallet,
    isPrivateKeyWallet,
    isBybitWallet,
    wallet: { walletId, walletType },
  } = useRedemptionWallet();
  const { data } = useUserLotteryStore();

  useEffect(() => {
    const checkAndShowGuide = async () => {
      // 1. 检查钱包状态
      if (!isConnectedWallet || !isBybitWallet || isPrivateKeyWallet) {
        return;
      }

      // 2. 无论是否展示弹窗，都先拉数据，保证先获取到剩余票数的数据
      let data = null;
      try {
        data = await userLotteryStore
          .getState()
          .getUserRewardStatus({ walletId, walletType }, true);
      } catch (error) {
        console.error('getUserRewardStatus error', error);
      }

      // 3. 检查本地存储
      if (!shouldShowGuide()) {
        return;
      }

      if (!data) {
        return;
      }

      // 所有条件满足，显示引导
      setShowGuide(true);
    };

    checkAndShowGuide();
  }, [
    isConnectedWallet,
    isBybitWallet,
    isPrivateKeyWallet,
    walletId,
    walletType,
  ]);

  return {
    showGuide,
    setShowGuide,
    // 返回数据，因为确定在显示 Modal 时数据一定存在
    remainingTickets: data?.remainingLotteryTimes ?? 0,
  };
};
